/** Board copy for /about and /contact. */
export const ABOUT_BIO = "ما بجي لصحّح تربيتك. بجي لنفهم سوا شو عم يصير مع طفلك، وشو الخطوة الصغيرة اللي بتغيّر البيت.";

/** Groups an E.164 number as "+CC 123 456 789": calling code from the first 3 digits, then groups of 3. */
export function formatPhoneGrouped(raw?: string | null): string {
  const d = (raw ?? "").replace(/\D/g, "");
  if (!d) return "";
  const rest = d.slice(3).match(/.{1,3}/g) ?? [];
  return ["+" + d.slice(0, 3), ...rest].join(" ");
}

export const ABOUT_PRINCIPLES = [
  { title: "الأمان أولًا", text: "الأمان قبل الانضباط. الطفل اللي بيحسّ بالأمان بيتعلّم، وبيسمع، وبيتغيّر. وبدون أمان، كل تقنية بتضل مؤقتة." },
  { title: "الكرامة", text: "ما في طفل «مشكلة»، وما في أهل بيستاهلوا اللوم. السلوك رسالة، وشغلنا نفهمها سوا — بدون تخويف ولا إهانة." },
  { title: "القدوة", text: "الطفل بيتعلّم من اللي بيشوفه قبل اللي بيسمعه. هدوء الأهل، وطريقة تعاملهم مع الغضب والخطأ، هي الدرس الأول." },
] as const;

export const ABOUT_CREDENTIAL = "استشارية تربوية ونفسية · دكتوراه في التربية – جامعة دمشق";

/** Address phrase from site_settings.clinic_address_ar; the board wording is used when it is the default address. */
export function clinicPlace(address?: string | null): string {
  const a = (address ?? "").trim();
  if (!a || a === "أبو رمانة، دمشق") return "بأبو رمانة بدمشق";
  return `في ${a}`;
}
export function aboutWorkLine(address?: string | null): string {
  return `بشتغل مع الأهل والطلاب بالعالم العربي وبالمهجر — أونلاين، وبالعيادة ${clinicPlace(address)}. كل المحتوى مبني على التربية الحساسة للصدمات وعلم الأعصاب.`;
}

export const WHATSAPP_PREFILL = "مرحباً، عندي سؤال";

import { SOCIAL, instagramUrl } from "@/lib/social";

/** Social pills for /contact, all URLs from src/lib/social.ts. */
export function socialPills(instagramSetting?: string | null) {
  return [
    { id: "instagram", label: "إنستغرام", figure: "1M+", href: instagramUrl(instagramSetting) },
    { id: "tiktok", figure: null, label: "تيك توك", href: SOCIAL.tiktok },
    { id: "youtube", figure: null, label: "يوتيوب", href: SOCIAL.youtube },
    { id: "facebook", figure: null, label: "فيسبوك", href: SOCIAL.facebook },
    { id: "threads", figure: null, label: "Threads", href: SOCIAL.threads },
  ] as const;
}
